<template>
  <div id="login">
    <div class="loginContainer">
      <img src="@/assets/img/login/Signin_logo_2.png" class="logoImg" />
      <label class="lblSiginTitle">{{ $t('Login.Login') }}</label>
      <label class="lblSiginSubTitle">{{ $t('Login.UserSystemTitle') }}</label>

      <div class="formWrapping">
        <div style="line-height: 34px">{{ $t('Login.Account') }}</div>
        <input type="text" class="loginKeyin" v-model.trim="account" placeholder="Username" />
        <div style="line-height: 34px">{{ $t('Login.Password') }}</div>
        <input type="password" class="loginKeyin" v-model.trim="password" @keyup.enter="Login" placeholder="Password" />
      </div>
      <button id="btnLogin" class="btnConfirm" @click="Login">{{ $t('Login.Login') }}</button>
      <button class="btnforgetPW" @click="Forgetpw">
        {{ $t('Login.ForgetPassword') }}
      </button>
    </div>
    <div class="loginBackground"></div>
  </div>
</template>

<script>
import sha256 from 'sha256';

export default {
  mounted() {
    this.backPage = this.GetParameterByName('page') != null ? this.GetParameterByName('page') : '';
  },
  data() {
    return {
      account: '',
      password: '',
      errorCode: 0,
      backPage: '',
    };
  },
  methods: {
    Login: function () {
      let errCode = this.ChkLoginData(this.account, this.password);
      //console.log(`errCode = ${errCode}`);
      if (errCode != 0) {
        this.errorCode = errCode;
        this.$toasted.show(this.ErrorMessage(), {
          icon: 'warning',
          position: 'bottom-center',
          duration: 2500,
        });
        return;
      }

      let loading = this.$loading.show({ backgroundColor: 'rgba(0,0,0,0.0)' });
      this.$store
        .dispatch('LOGIN', {
          Account: this.account,
          Password: sha256(this.password),
        })
        .then((code) => {
          loading.hide();
          this.errorCode = code;
          if (code == 0 || code == 2099) {
            this.$i18n.locale = localStorage.getItem('nowLanguageID');
            if (this.backPage != '') {
              this.$router.push({ path: this.backPage });
            } else {
              this.$router.push({ path: '/Home' });
            }
          } else {
            this.$toasted.show(this.ErrorMessage(), {
              icon: 'warning',
              position: 'bottom-center',
              duration: 2500,
            });
          }
        });
    },
    Forgetpw() {
      this.$router.push({ path: '/ForgetPW' });
    },
    ErrorMessage() {
      //error code : 100X = 前端驗證 200X = 後端驗證
      switch (this.errorCode) {
        case 0:
          return '';
        case 1001:
          return this.$t('Login.ErrMsg.KeyinAcc');
        case 1002:
          return this.$t('Login.ErrMsg.KeyinPW');
        case 2001:
          return this.$t('Login.ErrMsg.ErrAcc');
        case 2002:
          return this.$t('Login.ErrMsg.ErrPW');
        case 2003:
          return this.$t('Login.ErrMsg.ErrAuth');
        case 2004:
          return this.$t('Login.ErrMsg.ErrAuth');
        default:
          return this.$t('Login.ErrMsg.ErrNotDefine', { msg: this.errorCode });
      }
    },
  },
};
</script>
